"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_tooltip_1 = require("react-tooltip");
var formatter_1 = require("../../../helpers/formatter");
var index_1 = require("../components/layout/index");
var index_2 = require("../components/inputs/index");
var SpecialWorklogs = /** @class */ (function (_super) {
    __extends(SpecialWorklogs, _super);
    function SpecialWorklogs(newProps) {
        var _this = _super.call(this, newProps) || this;
        _this.state = { expanded: true };
        return _this;
    }
    SpecialWorklogs.prototype.worklogOnChange = function (worklog, target) {
        worklog.approvedHours = target.value;
        this.props.updateWorkLog(worklog);
    };
    SpecialWorklogs.prototype.renderLogs = function (worklog, index) {
        var _this = this;
        var specialType = worklog.specialType;
        var invalid = worklog.approvedHours + worklog.hours === 0;
        var operationPermission = this.props.getWorkLogPermission(worklog);
        return (React.createElement("tr", { key: index, className: invalid ? 'invalid' : '' },
            React.createElement("td", { className: "type-column" },
                React.createElement(index_1.Row, null,
                    React.createElement("i", { className: "material-icons location-icon " }, "start"),
                    operationPermission.UPDATE && this.props.editable ?
                        React.createElement("span", { className: "edit-button", onClick: function () { return _this.props.onEditClick && _this.props.onEditClick(worklog); } }, specialType && specialType.description || '')
                        : specialType && specialType.description || '')),
            React.createElement("td", null, formatter_1.Hour.durationToHourMinuteString(worklog.hours)),
            React.createElement("td", null, worklog.description && (React.createElement("div", { "data-tip": worklog.description, "data-for": worklog._id, className: "tooltip" },
                React.createElement("i", { className: "material-icons" }, "info"),
                React.createElement(react_tooltip_1.default, { id: worklog._id, effect: "solid" })))),
            React.createElement("td", null, operationPermission.CONTROL && this.props.editable ?
                React.createElement(index_2.HourInput, { name: "approvedHours", onChange: function (target) { return _this.worklogOnChange(worklog, target); }, value: worklog.approvedHours || 0, displayFormat: function (hours) { return formatter_1.Hour.durationToHourMinuteString(hours); }, required: true }) :
                "".concat(worklog.approvedHours || 0, "h"))));
    };
    SpecialWorklogs.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement("div", { className: "clickable project-item", onClick: function () { return _this.setState({ expanded: !_this.state.expanded }); } },
                React.createElement(index_1.Row, { justifyContent: "space-between" },
                    React.createElement("div", null,
                        React.createElement("i", { className: "material-icons project-icon" }, "hourglass_empty"),
                        React.createElement("span", { className: "project-name" }, "Speciale tijden")),
                    React.createElement("i", { className: "material-icons expand-icon" }, this.state.expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'))),
            React.createElement("table", null,
                React.createElement("tbody", null, this.state.expanded &&
                    this.props.worklogs.map(function (worklog, index) { return _this.renderLogs(worklog, index); })))));
    };
    return SpecialWorklogs;
}(React.Component));
exports.default = SpecialWorklogs;
